export const METRICS = {
  wilayah: { label: "Jumlah Kantor Wilayah" },
  cabang: { label: "Jumlah Kantor Cabang" },
  resort: { label: "Jumlah Resort" },
  anggota: { label: "Jumlah Anggota" },
  petugas: { label: "Jumlah Petugas" },
  pinjaman: { label: "Jumlah Total Pinjaman", money: true },
  sisa: { label: "Jumlah Total Sisa Pinjaman", money: true },
  angsuran: { label: "Jumlah Angsuran", money: true },
  simpanan: { label: "Jumlah Simpanan (Setoran)", money: true },
  penarikan: { label: "Jumlah Penarikan", money: true },
  kas_masuk: { label: "Jumlah Kas Masuk", money: true },
  kas_keluar: { label: "Jumlah Kas Keluar", money: true },
};
